"use strict";
export const selectWalletHideSmallBalancesSetting = (state) => state.userSettings.hideSmallBalances;
export const selectWalletHideSpamTokensSetting = (state) => state.userSettings.hideSpamTokens;
export const selectCurrentLanguage = (state) => state.userSettings.currentLanguage;
export const selectIsTestnetModeEnabled = (state) => state.userSettings.isTestnetModeEnabled ?? false;
